import {config} from "../config";
import {ICountryService} from "./website-country-service";

export class CountryService {
  nyCountryService: ICountryService = null;

  readonly COUNTRY_SERVICE_TAG = 'NY_COUNTRY_SERVICE';

  constructor() {
    this.initCountryService();
  }

  initCountryService() {
    if (window && window[this.COUNTRY_SERVICE_TAG]) {
      this.nyCountryService = window[this.COUNTRY_SERVICE_TAG]
    } else {
      console.warn("NY_COUNTRY_SERVICE not present");
    }
  }

  getCountryCode(): string {
    let url = window.location.href;
    let fragments = url.substr(url.indexOf('newyorker.de/') + 13).split('/'); // split URL path in segments
    let cc = config.defaultLang;
    if (fragments && fragments.length > 0) {
      cc = fragments[0];
      if (!cc || cc === '' || cc.startsWith("host") || cc.length > 2) {
        cc = config.defaultLang;
      }
    }

    return cc;
  }

  getISOLanguageCodeForCountry(countryCode: string) {
    if (this.nyCountryService) {
      const country = this.nyCountryService.countries.find(c => c.iso_3166.toUpperCase() === countryCode.toUpperCase());
      return `${country.iso_639}-${country.iso_3166.toUpperCase()}`
    }

    return 'de-DE'
  }

  getLanguageForCountry(countryCode: string) {
    if (this.nyCountryService) {
      return this.nyCountryService?.countries?.find(c => c.iso_3166.toUpperCase() === countryCode.toUpperCase())?.iso_639;
    }
    return config.defaultLang;
  }

  showOriginalPrice(countryCode: string): boolean {
    if (this.nyCountryService) {
      return this.nyCountryService?.countries.find(c => c.iso_3166.toUpperCase() === countryCode.toUpperCase()).showOriginalPrice;
    }

    return true
  }

  showVariablePriceCaption(countryCode: string): boolean {
    if (!this.nyCountryService) {
      return false;
    }

    const country = this.nyCountryService.countries.find(c => c.iso_3166.toUpperCase() === countryCode.toUpperCase());

    return country?.showVariablePriceCaption === true;
  }

  isRestricted(countryCode: string): boolean {
    if (this.nyCountryService) {
      return this.nyCountryService?.countries?.find(c => c.iso_3166.toUpperCase() === countryCode.toUpperCase())?.restricted;
    }
  }

}

export const NY_CountryService = new CountryService();
